import { IoIosAddCircle } from "react-icons/io";
import WorkTable from "./WorkTable";

const Work = ({ work, setWork, fromDate, setFromDate, toDate, setToDate, occupation, setOccupation, employerName, setEmployerName,  workAddress, setWorkAddress }) => {

    const addWork = () => {
        
        if(fromDate !== '' && toDate !== '' && occupation !== '' && employerName !== ''  && workAddress !== '' ) {
            console.log('jjjj')
            let data = {
                fromDate,
                toDate,
                occupation,
                employerName,
                workAddress

            }

            setWork([...work, data]);
            setFromDate('');
            setToDate('');
            setOccupation('');
            setEmployerName('');
            setWorkAddress('');
        }
    }
    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Work / Employment</h5>
            <div className="divider mb-5"></div>

            <div className="row">
                <div className="input-field col s12 m4">
                    <input id="fromDate" type="text" onChange={(e) => setFromDate(e.target.value)} value={fromDate} />
                    <label htmlFor="fromDate" className="active">From Date: (e.g January 2020)</label>
                </div>
                <div className="input-field col s12 m4">
                    <input id="toDate" type="text" onChange={(e) => setToDate(e.target.value)} value={toDate} />
                    <label htmlFor="toDate" className="active">To Date: (e.g June 2020/Current)</label>
                </div>
                <div className="input-field col s12 m4">
                    <input  id="occupation" type="text" onChange={(e) => setOccupation(e.target.value)} value={occupation} />
                    <label htmlFor="occupation" className="active">Occupation / Job Title: </label>
                </div>
                <div className="input-field col s12 m5">
                    <input id="employerName" type="text" onChange={(e) => setEmployerName(e.target.value)} value={employerName} />
                    <label htmlFor="employerName" className="active">Employer Name: </label>
                </div>
                <div className="input-field col s12 m7">
                    <textarea id="workAddress" className="materialize-textarea" onChange={(e) => setWorkAddress(e.target.value)} value={workAddress} ></textarea>
                    <label htmlFor="workAddress" className="active">Address: </label>
                </div>
            </div>  
            <div className="control">
                <div 
                    className="button is-success mt-2"
                    onClick={addWork}
                >
                    <span className="icon">
                        <IoIosAddCircle size="1.25rem" color="white"/>
                    </span>
                    <span className="white-text">Add </span>
                </div>
            </div>
            {
                work.length !== 0 && <WorkTable work={work}  setWork={setWork}/>
            }         
            <div className="mt-4 mb-4">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>For Block Release and Part-Time Applications.</p>
            </div>
        </>
     );
}
 
export default Work;